<template>
  <div class="formgrid grid vertical-container">
    <div class="col-2">
      <Toolbar class="p-0">
        <template v-slot:start>
          <Button title="Обновить" icon="pi pi-refresh" @click="loadScript" />
          <Button title="Добавить" :icon="newScript ? 'pi pi-minus' : 'pi pi-plus'" class="ml-1"
            @click="onClickNewScript" />
          <Button title="Удалить" icon="pi pi-trash" class="p-button-danger ml-1" @click="isDelete = true"
            :disabled="!selectedScript || newScript" />
        </template>
      </Toolbar>
      <div :style="[disableTable ? 'pointer-events: none' : '']">
        <DataTable id="data_table_script" :value="script" editMode="cell" selectionMode="single" scrollable
          :scrollHeight="scrollHeight" @cell-edit-complete="onCellEditComplete" dataKey="script_id"
          v-model:selection="selectedScript" class="editable-cells-table p-datatable-sm p-datatable-gridlines"
          responsiveLayout="scroll" autoLayout :loading="isLoadingScript" @update:selection="onSelectedScript" :pt="{
            column: {
              bodycell: ({ state }) => ({
                class: [{ 'pt-0 pb-0': state['d_editing'] }]
              })
            }
          }">
          <template #empty> Записи не найдены. </template>
          <template #loading> Записи загружаются. Пожалуйста подождите. </template>
          <Column field="script_name" header="Наименование скрипта" sortable filterMatchMode="in">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" style="width: 100%" autofocus @change="isChangeScript = true" />
            </template>
          </Column>
        </DataTable>
      </div>
      <Dialog v-model:visible="isDelete" :style="{ width: '550px' }" modal>
        <template #header>
          <i class="pi pi-question-circle mr-3" style="font-size: 2rem; color: rgb(204,204,0)" />
          <div class="col-10 font-bold text-center" style="font-size: 20px">
            Подтверждение действий
          </div>
        </template>

        <div class="confirmation-content">
          <div class="text-center">
            <span v-if="selectedScript" :style="{ 'font-size': '1.2rem' }">Удалить скрипт: <b>{{
              selectedScript["script_name"]
            }}</b>?</span>
          </div>
        </div>
        <template #footer>
          <Button label="Нет" icon="pi pi-times" class="p-button-text" @click="isDelete = false" />
          <Button label="Да" icon="pi pi-check" class="p-button-text" @click="deleteRow()" />
        </template>
      </Dialog>
    </div>
    <div class="col-10">
      <Button v-if="!scriptId" label="Создать скрипт для текущего объекта" icon="pi pi-plus"
        class="p-button-succes ml-2" @click="addNewFS()" />
      <br v-if="!scriptId" />
      <b> {{ selectedScript ? selectedScript.script_name : "Скрипт не выбран" }}</b>
      <FormScript v-if="selectedScript && selectedScript.script_id" :scriptId="selectedScript.script_id" />
      <div class="mt-2">
        <TabView>
          <TabPanel>
            <template #header>
              <b class="mr-2">Заполнение формы</b>
            </template>
            <div v-if="selectedScript">
              <Dropdown modelValue="js" :options="lang" optionLabel="name" optionValue="name" appendTo="body" disabled>
              </Dropdown>
              <Button label="Сохранить" icon="pi pi-save" class="p-button-text component-left"
                @click="onSaveProcScript(selectedScript)" />
              <Highlighter v-model="selectedScript.facility_changed_script" langName="js"
                @update:modelValue="isChangeScriptText = true"></Highlighter>
            </div>
          </TabPanel>
          <TabPanel>
            <template #header>
              <b class="mr-2">Обработка объекта</b>
            </template>
            <div v-if="selectedScript">
              <Dropdown modelValue="js" :options="lang" optionLabel="name" optionValue="name" appendTo="body" disabled>
              </Dropdown>
              <Button label="Сохранить" icon="pi pi-save" class="p-button-text component-left"
                @click="onSaveProcScript(selectedScript)" />
              <Highlighter v-model="selectedScript.facility_process_script" langName="js"
                @update:modelValue="isChangeScriptText = true"></Highlighter>
            </div>
          </TabPanel>
          <TabPanel>
            <template #header>
              <b class="mr-2">Дизайн WEB</b>
            </template>
            <div v-if="selectedScript">
              <Dropdown modelValue="json" :options="lang" optionLabel="name" optionValue="name" appendTo="body"
                disabled>
              </Dropdown>
              <Button label="Сохранить" icon="pi pi-save" class="p-button-text component-left"
                @click="onSaveDesignWeb(selectedScript)" />
              <Highlighter v-model="selectedScript.design_web" langName="json"></Highlighter>
            </div>
          </TabPanel>
          <TabPanel>
            <template #header>
              <b class="mr-2">Заполнение формы(PC-версия)</b>
            </template>
            <div v-if="selectedScript">
              <Dropdown modelValue="pascal" :options="lang" optionLabel="name" optionValue="name" appendTo="body"
                disabled>
              </Dropdown>
              <Highlighter v-model="selectedScript.facility_changed_script_old" langName="pascal" readonly>
              </Highlighter>
            </div>
          </TabPanel>
          <TabPanel>
            <template #header>
              <b class="mr-2">Обработка объекта(PC-версия)</b>
            </template>
            <div v-if="selectedScript">
              <Dropdown modelValue="pascal" :options="lang" optionLabel="name" optionValue="name" appendTo="body"
                disabled>
              </Dropdown>
              <Highlighter v-model="selectedScript.facility_process_script_old" langName="pascal" readonly>
              </Highlighter>
            </div>
          </TabPanel>
        </TabView>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, nextTick, getCurrentInstance, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useToast } from 'primevue/usetoast';
import EventBus from '@/core/EventBus';
import FormScript from './FormScript.vue';
import Highlighter from '../components/Highlighter.vue';

const props = defineProps({
  scriptId: { type: Number, default: null },
  showError: { type: Boolean, default: false },
  scrolling: { type: Boolean, default: false },
});

const emit = defineEmits(['add-script']);

const store = useStore();
const route = useRoute();
const toast = useToast();
const instance = getCurrentInstance();
const proxy = instance.proxy;

const scriptService = ref(null);
const selectedScript = ref(null);
const lastScript = ref(null);
const disableTable = ref(false);
const newScript = ref(false);
const script = ref(null);
const isDelete = ref(false);
const isLoadingScript = ref(false);
const isChangeScript = ref(false);
const isChangeScriptText = ref(false);
const isLoading = reactive({ scripts: false, scriptId: false });
const lang = [
  { name: 'js' },
  { name: 'json' },
  { name: 'pascal' },
];

const scrollHeight = computed(() => {
  return window ? `${window.screen.height - 320}px` : '800px';
});

const checkSaveScript = () => {
  if (isChangeScriptText.value && confirm('Есть не сохраненный текст выбранного скрипта! Сохранить?')) {
    onSaveProcScript(selectedScript.value);
  }
};

const onSelectedScript = () => {
  if (isChangeScriptText.value) {
    toast.add({
      severity: 'warn',
      summary: 'Несохранённые изменения',
      detail: 'Предыдущий скрипт был изменён. Не забудьте сохранить перед переключением.',
      life: 5000,
    });
    isChangeScriptText.value = false;
  }
};

const addNewFS = () => {
  emit('add-script');
  setTimeout(() => loadScript(true), 2000);
};

const loadScript = (refresh = false) => {
  newScript.value = false;
  if (!scriptService.value) {
    scriptService.value = store.getters.nameToService(
      'BaseService',
      store.getters.info.login,
      store.getters.info.password,
      'script',
      'data'
    );
  }
  if (!store.getters.scripts || refresh) {
    isLoadingScript.value = true;
    scriptService.value
      .getData()
      .then((data) => {
        store.dispatch('setScripts', data);
        script.value = data;
        onSelectScript();
      })
      .catch((er) => {
        store.commit('SET_ERROR', { er });
      })
      .finally(() => (isLoadingScript.value = false));
  } else {
    script.value = store.getters.scripts;
    setTimeout(() => onSelectScript(), 50);
  }
};

const checkSelectScript = () => {
  if (isLoading.scripts && isLoading.scriptId) {
    onSelectScript();
  }
};

const onSelectScript = () => {
  if (props.scriptId && script.value?.length > 0) {
    let found = false;
    script.value.forEach((item) => {
      if (item.script_id === props.scriptId) {
        selectedScript.value = item;
        store.dispatch('setScript', item);
        found = true;
      }
    });
    if (!found) console.warn('Script не найден в dSetting');
  } else {
    console.warn(`ScriptId: ${props.scriptId} или scriptData: ${script.value?.length} пустой в dSetting`);
    store.dispatch('clearScript');
  }
  nextTick(() => EventBus.emit('on-start-execution', 'script'));
};

const onClickNewScript = () => {
  if (!newScript.value) {
    script.value.unshift({ script_id: null });
    selectedScript.value = script.value[0];
    newScript.value = true;
  } else {
    script.value = script.value.filter((item) => item.script_id !== null);
    newScript.value = false;
  }
};

const onCellEditComplete = (event) => {
  const { newData, field } = event;
  if (!isPositiveString(newData[field], field)) {
    event.preventDefault();
    return;
  }
  saveScript(event);
};

const isPositiveString = (value) => {
  return value ? value.trim().length > 0 : false;
};

const saveScript = (event) => {
  const { data, newData, field } = event;
  if (newData.script_id) {
    if (isChangeScript.value) {
      disableTable.value = true;
      scriptService.value
        .putData({ script_id: newData.script_id, script_name: newData.script_name }, 'name')
        .then(() => {
          toast.add({
            severity: 'success',
            summary: 'Имя скрипта обновлено',
            detail: 'Изменения успешно применены',
            life: 2000,
          });
          isChangeScript.value = false;
          data[field] = newData[field];
        })
        .catch((er) => {
          store.commit('SET_ERROR', { er });
          event.preventDefault();
        })
        .finally(() => (disableTable.value = false));
    }
  } else {
    disableTable.value = true;
    scriptService.value
      .insertData({
        script_id: null,
        script_name: newData.script_name,
        construction_script: null,
        facility_changed_script: null,
        facility_process_script: null,
        design_form: null,
      })
      .then((res) => {
        toast.add({
          severity: 'success',
          summary: 'Скрипт создан',
          detail: 'Новый скрипт успешно добавлен',
          life: 2000,
        });
        newScript.value = false;
        isChangeScript.value = false;
        data[field] = newData[field];
        data['script_id'] = res[0].script_id;
      })
      .catch((er) => {
        store.commit('SET_ERROR', { er });
        event.preventDefault();
      })
      .finally(() => (disableTable.value = false));
  }
};

const onSaveProcScript = (data) => {
  if (data.script_id && scriptService.value) {
    scriptService.value
      .putData(
        {
          facility_process_script: data.facility_process_script,
          facility_changed_script: data.facility_changed_script,
          construction_script: data.construction_script,
          script_id: data.script_id,
        },
        'script'
       )
       .then(() => {
         toast.add({
           severity: 'success',
           summary: 'Скрипт сохранён',
           detail: 'Изменения в скрипте успешно сохранены',
           life: 3000,
         });
        isChangeScriptText.value = false;
        store.dispatch('filterScriptLogs', route.params.facility_id);
      })
      .catch((er) => {
        store.commit('SET_ERROR', { er });
      });
  }
};

const onSaveDesignWeb = (data) => {
  if (data.script_id && scriptService.value) {
    scriptService.value
      .putData(
        {
          design_web: data.design_web,
          script_id: data.script_id,
        },
        'web'
       )
       .then(() => {
         toast.add({
           severity: 'success',
           summary: 'Дизайн сохранён',
           detail: 'Настройки дизайны успешно обновлены',
           life: 3000,
         });
        store.dispatch('filterScriptLogs', route.params.facility_id);
      })
      .catch((er) => {
        store.commit('SET_ERROR', { er });
      });
  }
};

const deleteRow = () => {
  disableTable.value = true;
  scriptService.value
    .deleteData({ script_id: selectedScript.value.script_id })
    .then(() => {
      toast.add({
        severity: 'success',
        summary: 'Скрипт удалён',
        detail: 'Запись скрипта успешно удалена из системы',
        life: 3000,
      });
      script.value = script.value.filter(
        (item) => item.script_id !== selectedScript.value.script_id
      );
      selectedScript.value = null;
    })
    .catch((er) => store.commit('SET_ERROR', er))
    .finally(() => {
      isDelete.value = false;
      disableTable.value = false;
    });
};

onMounted(() => {
  EventBus.on('on-load-script-data', () => nextTick(() => loadScript()));
  EventBus.on('on-check-save-script', () => checkSaveScript());
});

onBeforeUnmount(() => {
  EventBus.off('on-load-script-data');
  EventBus.off('on-check-save-script');
  checkSaveScript();
});

watch(
  () => props.scrolling,
  (val) => {
    if (val) {
      setTimeout(() => {
        const element = document
          .getElementById('data_table_script')
          ?.getElementsByClassName('p-highlight')[0];
        if (element) element.focus();
      }, 300);
    }
  }
);

watch(
  () => props.showError,
  (val) => {
    if (val && !props.scriptId) {
      store.commit('SET_ERROR', {
        er: 'Форма не привязана к скрипту. Для редактирования создайте новый скрипт или добавьте форму к существующему.',
        source: ['DesignSetting', 'showError'],
      });
    }
  }
);
</script>

<style scoped lang="scss">
.component-left {
  float: right;
}
</style>